import localForage from 'localforage';
import { RECORDINGS_STORE_NAME, CONTENT_STORE_NAME, RESULTS_STORE_NAME } from './constants';

let persistenceStorages = null;

export const getPersistenceStorages = () => persistenceStorages;

export const getStudentResultKey = (studentUid, measure) =>
    `student_${studentUid}_${measure}_result`;

export const initStorages = () => ({
    [RECORDINGS_STORE_NAME]: localForage.createInstance({
        name: RECORDINGS_STORE_NAME,
    }),
    [RESULTS_STORE_NAME]: localForage.createInstance({
        name: RESULTS_STORE_NAME,
    }),
    [CONTENT_STORE_NAME]: localForage.createInstance({
        name: CONTENT_STORE_NAME,
    }),
});

persistenceStorages = initStorages();
